export const createAnnouncementDto = {
    startDate: null,
    endDate: null,
    announcementName: null,
    announcementDetails: null,
    us: null,
    canada: null,
    eu: null,
    ap: null,
    lac: null,
    cemea: null,
    publishState: null,
}

export const updateAnnouncementDto = {
    startDate: null,
    endDate: null,
    announcementName: null,
    announcementDetails: null,
    us: null,
    canada: null,
    eu: null,
    ap: null,
    lac: null,
    cemea: null,
    publishState: null
}
